import React from 'react';
import TopNav from '../TopNav';

class Header extends React.Component {
  render() {
    return (
      <div className="header">
        <TopNav />
      </div>
    );
  }
}

export default Header;
